// React
import React, { useEffect, useState } from "react";

// Material-UI Core
import { Box, Typography } from "@material-ui/core";
import HomeIcon from "@material-ui/icons/Home";

// Custom Styles
import { ProgressPageStyles } from "Custom/StylesAppSpecific/DashboardSubViews/ProgressPageStyling";

// Custom ViewModels
import { ProgressViewModel } from "Custom/ViewModels/DashboardSubViewModels/ProgressViewModel";

interface ProgressViewProps {
    viewModelProgress: ProgressViewModel;
}

const ProgressView: React.FC<ProgressViewProps> = ({ viewModelProgress }) => {
    const progressPageStyles = ProgressPageStyles();
    const [latestActivityEl, setLatestActivityEl] = useState<HTMLDivElement | null>(null);

    useEffect(() => {
        if (latestActivityEl) {
            const rect = latestActivityEl.getBoundingClientRect();
            if (latestActivityEl.parentElement) {
                const containerRect = latestActivityEl.parentElement.getBoundingClientRect();
                latestActivityEl.parentElement.scrollTop = rect.top - containerRect.top - containerRect.height / 2 + rect.height / 2;
            }
        }
    }, [latestActivityEl]);

    const getActivityIconStyle = (activity: any) => {
        const colour = activity.isCompleted ? activity.activityColour : "#ced4da";
        return { backgroundColor: colour };
    };

    const getActivityTextStyle = (activity: any) => {
        const colour = activity.isCompleted ? "#191919" : "#808080";
        return { color: colour };
    };

    const renderMajorActivity = (activity: any) => (
        <Box>
            <Box />
            <Box className={progressPageStyles.majorActivityIcon} style={getActivityIconStyle(activity)}>
                <HomeIcon />
            </Box>
        </Box>
    );

    const renderMinorActivity = (activity: any) => (
        <Box>
            <Box />
            <Box className={progressPageStyles.minorActivityIcon} style={getActivityIconStyle(activity)} />
        </Box>
    );

    const renderActivities = (activities: any[]) => {
        const latestActivityId = viewModelProgress.latestActivityId;

        return activities.map((activity, index) => (
            <React.Fragment key={index}>
                <div
                    ref={ref => ref && latestActivityId === activity.getValue("id") && ref !== latestActivityEl && setLatestActivityEl(ref)}
                    className={`${progressPageStyles.progress} ${latestActivityId === activity.getValue("id") ? "latest" : ""}`}
                >
                    {renderMinorActivity(activity)}
                    <Box className={progressPageStyles.progressTextRow} style={getActivityTextStyle(activity)}>
                        <Typography className={progressPageStyles.progressTitle}>{activity.activityName}</Typography>
                        <Typography className={progressPageStyles.progressSubTitle}>{activity.completedDateFormatted}</Typography>
                    </Box>
                </div>
            </React.Fragment>
        ));
    };

    const renderProgress = () => {
        const latestActivityId = viewModelProgress.latestActivityId;

        return (
            <Box className={progressPageStyles.progresses}>
                <Box className={progressPageStyles.gradient} />
                {viewModelProgress.Activities.filter((a: any) => !a.isNotApplicable).map((activity: any, index: number) => (
                    <React.Fragment key={index}>
                        <div
                            ref={ref => ref && latestActivityId === activity.getValue("id") && ref !== latestActivityEl && setLatestActivityEl(ref)}
                            className={`${progressPageStyles.progress} ${latestActivityId === activity.getValue("id") ? "latest" : ""}`}
                        >
                            {renderMajorActivity(activity)}
                            <Box className={progressPageStyles.progressTextRow} style={getActivityTextStyle(activity)}>
                                <Typography className={progressPageStyles.progressTitle}>{activity.activityName}</Typography>
                                <Typography className={progressPageStyles.progressSubTitle}>{activity.completedDateFormatted}</Typography>
                            </Box>
                        </div>
                        {activity.hasActivities && renderActivities(activity.Activities)}
                    </React.Fragment>
                ))}
            </Box>
        );
    };

    return <>{renderProgress()}</>;
};

export default ProgressView;
